import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

/* ── Main Valuation Card (aubergine bg) ── */

export const MainValuationCard = styled.div`
  background: ${vimovaTheme.colors.primary};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 24px 32px 28px;
  position: relative;
  overflow: hidden;
  margin-top: 20px;

  @media print {
    background: ${vimovaTheme.colors.primary} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 24px 32px 28px !important;
    margin-top: 20px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const OrangeBracketDecoration = styled.div`
  position: absolute;
  top: 12px;
  left: 16px;
  opacity: 0.4;

  @media print {
    position: absolute !important;
    top: 12px !important;
    left: 16px !important;
    opacity: 0.4 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const GreenBracketDecoration = styled.div`
  position: absolute;
  bottom: 12px;
  right: 12px;
  opacity: 0.4;

  @media print {
    position: absolute !important;
    bottom: 12px !important;
    right: 12px !important;
    opacity: 0.4 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ValuationLabel = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.white};
  opacity: 0.6;
  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.white} !important;
    opacity: 0.6 !important;
    text-align: center !important;
    letter-spacing: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MainPrice = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 40px;
  color: ${vimovaTheme.colors.white};
  text-align: center;
  margin-top: 8px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 40px !important;
    color: ${vimovaTheme.colors.white} !important;
    text-align: center !important;
    margin-top: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PropertySummary = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.white};
  opacity: 0.6;
  text-align: center;
  margin-top: 4px;

  @media print {
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.white} !important;
    opacity: 0.6 !important;
    text-align: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Price Range Card ── */

export const RangeCard = styled.div`
  background: ${vimovaTheme.colors.backgroundLight};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 20px 24px;
  margin-top: 16px;
  position: relative;
  border-left: 4px solid ${vimovaTheme.colors.green};

  @media print {
    background: ${vimovaTheme.colors.backgroundLight} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 20px 24px !important;
    margin-top: 16px !important;
    border-left: 4px solid ${vimovaTheme.colors.green} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const RangeTrack = styled.div`
  position: relative;
  height: 6px;
  background: ${vimovaTheme.colors.backgroundMuted};
  border-radius: 3px;
  margin: 0 16px;

  @media print {
    height: 6px !important;
    background: ${vimovaTheme.colors.backgroundMuted} !important;
    border-radius: 3px !important;
    margin: 0 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const RangeHighlight = styled.div<{ $left: number; $width: number }>`
  position: absolute;
  top: -4px;
  left: ${({ $left }) => $left}%;
  width: ${({ $width }) => $width}%;
  height: 14px;
  background: rgba(165, 204, 116, 0.3);
  border-radius: 7px;

  &::after {
    content: '';
    position: absolute;
    top: 4px;
    left: 0;
    right: 0;
    height: 6px;
    background: ${vimovaTheme.colors.green};
    border-radius: 3px;
  }

  @media print {
    top: -4px !important;
    left: ${({ $left }) => $left}% !important;
    width: ${({ $width }) => $width}% !important;
    height: 14px !important;
    background: rgba(165, 204, 116, 0.3) !important;
    border-radius: 7px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    &::after {
      top: 4px !important;
      height: 6px !important;
      background: ${vimovaTheme.colors.green} !important;
      border-radius: 3px !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`

export const RangeMarker = styled.div<{ $position: number }>`
  position: absolute;
  top: -5px;
  left: ${({ $position }) => $position}%;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${vimovaTheme.colors.primary};
  transform: translateX(-50%);
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${vimovaTheme.colors.white};
    transform: translate(-50%, -50%);
  }

  @media print {
    top: -5px !important;
    left: ${({ $position }) => $position}% !important;
    width: 16px !important;
    height: 16px !important;
    border-radius: 50% !important;
    background: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    &::after {
      width: 6px !important;
      height: 6px !important;
      background: ${vimovaTheme.colors.white} !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`

export const RangeLabels = styled.div`
  position: relative;
  margin-top: 12px;
  height: 24px;

  @media print {
    position: relative !important;
    margin-top: 12px !important;
    height: 24px !important;
  }
`

export const RangeLabelItem = styled.div<{
  $highlight?: boolean
  $position: number
}>`
  position: absolute;
  left: ${({ $position }) => $position}%;
  transform: translateX(-50%);
  text-align: center;

  @media print {
    position: absolute !important;
    left: ${({ $position }) => $position}% !important;
    transform: translateX(-50%) !important;
    text-align: center !important;
  }
`

export const RangeLabelText = styled.div<{ $highlight?: boolean }>`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${({ $highlight }) =>
    $highlight ? vimovaTheme.colors.greenDark : vimovaTheme.colors.textMuted};

  @media print {
    font-size: 8px !important;
    color: ${({ $highlight }) =>
      $highlight
        ? vimovaTheme.colors.greenDark
        : vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const RangeLabelValue = styled.div<{ $highlight?: boolean }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${({ $highlight }) =>
    $highlight ? vimovaTheme.fontWeights.black : vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${({ $highlight }) =>
    $highlight ? vimovaTheme.colors.greenDark : vimovaTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-weight: ${({ $highlight }) =>
      $highlight
        ? vimovaTheme.fontWeights.black
        : vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${({ $highlight }) =>
      $highlight
        ? vimovaTheme.colors.greenDark
        : vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PricePerSqm = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  color: ${vimovaTheme.colors.textMuted};
  text-align: center;
  margin-top: 16px;

  @media print {
    font-size: 10px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    text-align: center !important;
    margin-top: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Two-Column Grid ── */

export const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 16px !important;
    margin-top: 16px !important;
  }
`

export const ValuationCard = styled.div`
  background: ${vimovaTheme.colors.backgroundLight};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 16px;

  @media print {
    background: ${vimovaTheme.colors.backgroundLight} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ValuationCardTitle = styled.h3`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 12px;
  color: ${vimovaTheme.colors.primary};
  margin: 0 0 16px 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 12px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AutoValuationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  & + & {
    margin-top: 12px;
  }

  @media print {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 8px !important;
  }
`

export const AutoValuationSource = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  color: ${vimovaTheme.colors.text};
  flex-shrink: 0;

  @media print {
    font-size: 10px !important;
    color: ${vimovaTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AutoValuationConfidence = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 8px;
  background: rgba(165, 204, 116, 0.15);
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 8px;
  color: ${vimovaTheme.colors.greenDark};

  @media print {
    padding: 2px 10px !important;
    border-radius: 8px !important;
    background: rgba(165, 204, 116, 0.15) !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 8px !important;
    color: ${vimovaTheme.colors.greenDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AutoValuationPrice = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 10px;
  color: ${vimovaTheme.colors.greenDark};
  margin-left: auto;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 10px !important;
    color: ${vimovaTheme.colors.greenDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ManualValuationRow = styled.div`
  & + & {
    margin-top: 16px;
  }

  @media print {
    & + & {
      margin-top: 16px !important;
    }
  }
`

export const ManualValuationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media print {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
  }
`

export const ManualValuationSubline = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;

  @media print {
    display: flex !important;
    align-items: baseline !important;
    justify-content: space-between !important;
    gap: 8px !important;
    margin-top: 2px !important;
  }
`

export const ManualValuationRange = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ManualValuationMethod = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  color: ${vimovaTheme.colors.text};

  @media print {
    font-size: 10px !important;
    color: ${vimovaTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ManualValuationPrice = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 10px;
  color: ${vimovaTheme.colors.greenDark};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 10px !important;
    color: ${vimovaTheme.colors.greenDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ManualValuationDescription = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Methodology ── */

export const MethodologySection = styled.div`
  margin-top: 16px;

  @media print {
    margin-top: 16px !important;
  }
`

export const MethodologyTitle = styled.h3`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 12px;
  color: ${vimovaTheme.colors.primary};
  margin: 0 0 8px 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 12px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MethodologyText = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textLight};
  line-height: 1.6;
  margin: 0;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    line-height: 1.6 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Disclaimer ── */

export const DisclaimerBox = styled.div`
  background: ${vimovaTheme.colors.backgroundWarm};
  border-radius: ${vimovaTheme.borderRadius.signature};
  border-left: 4px solid ${vimovaTheme.colors.orange};
  padding: 16px 20px;
  margin-top: 16px;

  @media print {
    background: ${vimovaTheme.colors.backgroundWarm} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    border-left: 4px solid ${vimovaTheme.colors.orange} !important;
    padding: 16px 20px !important;
    margin-top: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DisclaimerTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 10px;
  color: ${vimovaTheme.colors.orange};
  margin-bottom: 6px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 10px !important;
    color: ${vimovaTheme.colors.orange} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DisclaimerText = styled.p`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textLight};
  line-height: 1.6;
  margin: 0;

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    line-height: 1.6 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
